import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSurveyData, submitSurvey } from "../../services/SurveyApiService";
import "./ColexitRedirectPage.css";
import reliantLogo from "../../Assets/reliant_logo.png";
import colexitLogo from "../../Assets/colexit_logo.png";

const ColexitRedirectPage = () => {
  const { userGuid, surveyGuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [consumerEmail, setConsumerEmail] = useState("");

  useEffect(() => {
    let isMounted = true;
    getSurveyData(userGuid, surveyGuid)
      .then((data) => {
        if (!isMounted) return;
        setConsumerEmail(data.consumerEmail || "");
        const question = data.questions && data.questions[0];
        const response = question ? question.options && question.options[0] : null;
        const consentPayload = [{
          surveyResponseId: 0,
          surveyActivityId: surveyGuid,
          surveyId: data.surveyId,
          surveyQuestionId: question?.questionId,
          surveyQuestionText: question?.questionText,
          responseOptionId: response?.optionId ?? null,
          responseText: response?.optionText || "consented"
        }];
        return submitSurvey(consentPayload);
      })
      .then(() => {
        if (!isMounted) return;
        setLoading(false);
        window.location.href = `https://colexit.app/intake?ref=reliant&email=${encodeURIComponent(consumerEmail)}&token=v/nTxUZL0r0QX3AagFEWpQZQWouPuMveto8xp/ZglyE=`;
      })
      .catch(() => {
        if (!isMounted) return;
        setError("There was an error saving your consent. Please try again later.");
        setLoading(false);
      });
    return () => { isMounted = false; };
  }, [userGuid, surveyGuid, consumerEmail]);

  return (
    <div className="consent-bg">
      <div className="consent-card">
        <div className="consent-logos center-logos">
          <img src={reliantLogo} alt="Reliant logo" className="reliant-logo" />
          {error ? (
            <span className="transfer-error">
              <span className="transfer-error-circle">
                <span className="transfer-error-excl">&#33;</span>
              </span>
            </span>
          ) : (
            <span className="transfer-dots">
              <span className="transfer-dot" />
              <span className="transfer-dot" />
              <span className="transfer-dot" />
              <span className="transfer-dot" />
              <span className="transfer-dot" />
            </span>
          )}
          <img src={colexitLogo} alt="Colexit logo" className="colexit-logo" />
        </div>
        {loading && (
          <div className="redirect-loading">
            <div>Securely sharing your data...</div>
          </div>
        )}
        {error && (
          <div className="redirect-error-message">
            <div className="redirect-error-text">
              We couldn't complete the transfer just now.<br />
              <span className="redirect-error-subtext">
                Please reload the page to try again.<br />
                This is a routine step and usually resolves the issue.
              </span>
            </div>
            <button
              className="reload-btn"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ColexitRedirectPage;
